import React, { FC, useState } from "react"
import { makeStyles, Dialog, DialogContent, DialogContentText, DialogTitle, ListItemIcon, IconButton, ListItemText, ListItem, SvgIcon, ListSubheader, List } from "@material-ui/core"
import  thePatchNotes  from "./patchNotesDocument.json" 
import SpeakerNotesIcon from '@material-ui/icons/SpeakerNotes';

const useStyles = makeStyles(theme => ({

    listItems: {
        maxHeight: "400px",
      },
}))

  interface Props {// will be used for future prop implementations
  }

const changeLog = () => { // removeing the splitting Char (-)
    let listOfChanges = thePatchNotes.patches
  return listOfChanges.split('-')
}

export const PatchNotes: FC<Props> = ({ }) => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const divRef = React.useRef(null);

    const handleShortcutOpen = () => { // opens the patchnote list
        setOpen(true)
      };
      
      const handleShortcutClose = () => { //closes the patchnote list and clears AnchorE1
        setOpen(false)
        setAnchorEl(null)
      };

    return(
      <>
      <ListItem onClick={handleShortcutOpen}>
          <ListItemIcon>
              <SvgIcon><SpeakerNotesIcon/></SvgIcon>
          </ListItemIcon>
          <ListItemText primary={<b> Patch Notes </b>} />
      </ListItem>

        <Dialog open={open} onClick={() => handleShortcutClose()} aria-labelledby="loading-symbol" aria-describedby="loading-des" >
        <DialogTitle id="alert-dialog-title">{"Nye tilføjelser i Webportalen"}</DialogTitle>
        <DialogContent style={{display: "flex", alignContent: "center", alignSelf: "center", alignItems: "center"}}>
          <DialogContentText id="alert-dialog-description" > 
            <List className={classes.listItems}>
          {changeLog().map((str: string, index) => (
                      <ListItem key={index} alignItems="flex-start">
                        <ListItemText primary={(index+1) + ". " + str}/>
                        </ListItem>   
                     ))}   
            </List>
          </DialogContentText>   
        </DialogContent>
        </Dialog>     
      </> 
    )
  }